export default "__VITE_ASSET__C6KeRpH8__"